import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 15l-3 -3l3 -3","key":"svg-0"}],["path",{"d":"M11 15l-3 -3l3 -3","key":"svg-1"}],["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-2"}]]

const IconSquareChevronsLeft = createReactComponent('outline', 'square-chevrons-left', 'SquareChevronsLeft', __iconNode);

export default IconSquareChevronsLeft;